scoreJson = JSON.parse('[{ "tags": ["fleas-1", "home-3"], "url": "/products/natural-flea-tick-mosquito-control-for-dogs-evolv" }, { "tags": ["pet-yard-3"], "url": "/products/worry-free-bundle" }, { "tags": ["ants-1"], "url": "/products/4-oz-flea-tick-spray-for-pets-home" }, { "tags": ["spiders-1", "mosquito-1"], "url": "/collections/spider-repellent" }, { "tags": ["home-3"], "url": "/collections/spider-repellent" }, { "tags": ["other-99", "home-3"], "url": "/products/indoor-natural-pest-control-kills-repels-100s-of-pests" }, { "tags": ["everywhere-3"], "url": "/products/pest-free-summer-pack" }, { "tags": ["both-4"], "url": "/pages/both-dogs-and-cats" }, { "tags": ["dog-l"], "url": "/products/32-oz-flea-tick-spray-for-pets-home" }, { "tags": ["2-dogs"], "url": "/products/32-oz-flea-tick-spray-for-pets-home" }, { "tags": ["pet-home-3"], "url": "/products/32-oz-flea-tick-spray-for-pets-home" }, { "tags": ["dog-s"], "url": "/products/4-oz-flea-tick-spray-for-pets-home" }, { "tags": ["1-cat"], "url": "/products/4-oz-flea-tick-spray-for-pets-home" }, { "tags": ["2-cats"], "url": "/products/4-oz-flea-tick-spray-for-pets-home" }, { "tags": ["dog-m"], "url": "/products/16-oz-flea-tick-spray-for-pets-home" }]');
fleasYard = JSON.parse('[{"url": "/collections/flea-treatment-for-yard/products/ready-to-use-natural-flea-tick-control-for-yard-garden"}, {"url": "/collections/flea-treatment-for-yard/products/flea-tick-concentrate-for-yard-garden-32oz"}, {"url": "/collections/flea-treatment-for-yard/products/flea-tick-concentrate-for-yard-garden-128oz"}]');
fleasEwerywhere = JSON.parse('[{"url": "/collections/yard-bundle-save/products/worry-free-bundle"}, {"url": "/collections/yard-bundle-save/products/worry-free-bundle"}, {"url": "/collections/yard-bundle-save/products/house-treatment-kit-natural-flea-tick-control-pets-home-yard"}]');
antsYard = JSON.parse('[{"url": "/collections/outdoor-pest-control-1/products/outdoor-ready-to-use-natural-pest-control-for-yard-garden"}, {"url": "/products/outdoor-pest-control-concentrate-for-yard-garden-32oz"}, {"url": "/products/outdoor-pest-control-concentrate-for-yard-garden-128oz"}]');
defaultYard = JSON.parse('[{"url": "/collections/dogs-bundle-save/products/pest-free-summer-pack"}, {"url": "/collections/dogs-bundle-save/products/pest-free-summer-pack"}, {"url": "/collections/dogs-bundle-save/products/pest-free-summer-pack"}]');
fleasPreventionYard = JSON.parse('[{"url": "/collections/flea-treatment-for-yard/products/ready-to-use-natural-flea-tick-control-for-yard-garden"}, {"url": "/collections/dogs-bundle-save/products/pest-free-summer-pack"}, {"url": "/collections/dogs-bundle-save/products/pest-free-summer-pack"}]');

const linksArr = new Map([
  ['fleas-1,prevention-2,pet-yard-3', '/collections/yard-bundle-save/products/worry-free-bundle'],
  ['fleas-1,active-2,pet-yard-3', '/collections/yard-bundle-save/products/worry-free-bundle'],
  ['fleas-1,active-2,everywhere-3', '/collections/yard-bundle-save/products/house-treatment-kit-natural-flea-tick-control-pets-home-yard'],
  ['fleas-1,active-2,pet-3,dog-4,1-dog,dog-s', '/products/4-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,active-2,pet-3,dog-4,1-dog,dog-m', '/products/16-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,active-2,pet-3,dog-4,1-dog,dog-l', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,active-2,pet-3,dog-4,2-dogs', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,active-2,pet-3,cat-4,1-cat', '/products/4-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,active-2,pet-3,cat-4,2-cats', '/products/4-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,active-2,pet-3,both-4', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,active-2,home-3', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,active-2,pet-home-3', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,prevention-2,pet-3,dog-4,1-dog,dog-s', '/products/4-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,prevention-2,pet-3,dog-4,1-dog,dog-m', '/products/16-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,prevention-2,pet-3,dog-4,1-dog,dog-l', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,prevention-2,pet-3,dog-4,2-dogs', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,prevention-2,pet-3,cat-4,1-cat', '/products/4-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,prevention-2,pet-3,cat-4,2-cats', '/products/4-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,prevention-2,pet-3,both-4', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,prevention-2,home-3', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,prevention-2,pet-home-3', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['fleas-1,prevention-2,everywhere-3', '/collections/yard-bundle-save/products/house-treatment-kit-natural-flea-tick-control-pets-home-yard'],
  ['ants-1,active-2,pet-3,dog-4,1-dog,dog-s', '/products/4-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,active-2,pet-3,dog-4,1-dog,dog-m', '/products/16-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,active-2,pet-3,dog-4,1-dog,dog-l', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,active-2,pet-3,dog-4,2-dogs', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,active-2,pet-3,cat-4,1-cat', '/products/4-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,active-2,pet-3,cat-4,2-cats', '/products/4-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,active-2,pet-3,both-4', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,active-2,pet-yard-3', '/collections/yard-bundle-save/products/worry-free-bundle'],
  ['ants-1,active-2,home-3', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,prevention-2,pet-3,dog-4,1-dog,dog-s', '/products/4-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,prevention-2,pet-3,dog-4,1-dog,dog-m', '/products/16-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,prevention-2,pet-3,dog-4,1-dog,dog-l', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,prevention-2,pet-3,dog-4,2-dogs', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,prevention-2,pet-3,cat-4,1-cat', '/products/4-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,prevention-2,pet-3,cat-4,2-cats', '/products/4-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,prevention-2,pet-3,both-4', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['ants-1,prevention-2,pet-yard-3', '/collections/yard-bundle-save/products/worry-free-bundle'],
  ['ants-1,prevention-2,home-3', '/products/32-oz-flea-tick-spray-for-pets-home'],
  ['mosquito-1,active-2,pet-yard-3', '/collections/yard-bundle-save/products/worry-free-bundle'],
  ['mosquito-1,active-2,home-3', '/products/indoor-natural-pest-control-kills-repels-100s-of-pests'],
  ['mosquito-1,prevention-2,pet-yard-3', '/collections/yard-bundle-save/products/worry-free-bundle'],
  ['mosquito-1,prevention-2,home-3', '/products/indoor-natural-pest-control-kills-repels-100s-of-pests'],
  ['spiders-1,active-2,pet-yard-3', '/collections/yard-bundle-save/products/worry-free-bundle'],
  ['spiders-1,prevention-2,pet-yard-3', '/collections/yard-bundle-save/products/worry-free-bundle'],
  ['other-1,active-2,pet-yard-3', '/collections/yard-bundle-save/products/worry-free-bundle'],
  ['other-1,prevention-2,pet-yard-3', '/collections/yard-bundle-save/products/worry-free-bundle'],
  ['other-1,active-2,home-3', '/products/indoor-natural-pest-control-kills-repels-100s-of-pests'],
  ['other-1,prevention-2,home-3', '/products/indoor-natural-pest-control-kills-repels-100s-of-pests'],
  ['default', ''],
]);

const yardsArr = new Map([
  ['fleas-1,prevention-2,yard-3',
    ['/collections/flea-treatment-for-yard/products/ready-to-use-natural-flea-tick-control-for-yard-garden',
      '/collections/yard-bundle-save/products/worry-free-bundle',
      '/collections/yard-bundle-save/products/worry-free-bundle'],
  ],
  ['fleas-1,prevention-2,yard-3',
    ['/collections/flea-treatment-for-yard/products/ready-to-use-natural-flea-tick-control-for-yard-garden',
      '/collections/yard-bundle-save/products/worry-free-bundle',
      '/collections/yard-bundle-save/products/worry-free-bundle'],
  ],
  ['fleas-1,active-2,yard-3',
    ['/collections/dogs-bundle-save/products/pest-free-summer-pack',
      '/collections/dogs-bundle-save/products/pest-free-summer-pack',
      '/collections/dogs-bundle-save/products/pest-free-summer-pack'],
  ],
  ['ants-1,prevention-2,yard-3',
    ['/collections/outdoor-pest-control-1/products/outdoor-ready-to-use-natural-pest-control-for-yard-garden',
      '/collections/yard-bundle-save/products/worry-free-bundle',
      '/collections/yard-bundle-save/products/worry-free-bundle'],
  ],
  ['mosquito-1,prevention-2,yard-3',
    ['/collections/outdoor-pest-control-1/products/outdoor-ready-to-use-natural-pest-control-for-yard-garden',
      '/collections/yard-bundle-save/products/worry-free-bundle',
      '/collections/yard-bundle-save/products/worry-free-bundle'],
  ],
  ['spiders-1,prevention-2,yard-3',
    ['/collections/outdoor-pest-control-1/products/outdoor-ready-to-use-natural-pest-control-for-yard-garden',
      '/collections/yard-bundle-save/products/worry-free-bundle',
      '/collections/yard-bundle-save/products/worry-free-bundle'],
  ],
  ['spiders-1,active-2,yard-3',
    ['/collections/outdoor-pest-control-1/products/outdoor-ready-to-use-natural-pest-control-for-yard-garden',
      '/collections/yard-bundle-save/products/worry-free-bundle',
      '/collections/yard-bundle-save/products/worry-free-bundle'],
  ],
  ['other-1,active-2,yard-3',
    ['/collections/outdoor-pest-control-1/products/outdoor-ready-to-use-natural-pest-control-for-yard-garden',
      '/collections/yard-bundle-save/products/worry-free-bundle',
      '/collections/yard-bundle-save/products/worry-free-bundle'],
  ],
  ['other-1,prevention-2,yard-3',
    ['/collections/outdoor-pest-control-1/products/outdoor-ready-to-use-natural-pest-control-for-yard-garden',
      '/collections/yard-bundle-save/products/worry-free-bundle',
      '/collections/yard-bundle-save/products/worry-free-bundle'],
  ],
  ['ants-1,active-2,yard-3',
    ['/collections/outdoor-pest-control-1/products/outdoor-ready-to-use-natural-pest-control-for-yard-garden',
      '/products/outdoor-pest-control-concentrate-for-yard-garden-32oz',
      '/products/outdoor-pest-control-concentrate-for-yard-garden-128oz'],
  ],
  ['mosquito-1,active-2,yard-3',
    ['/collections/outdoor-pest-control-1/products/outdoor-ready-to-use-natural-pest-control-for-yard-garden',
      '/products/outdoor-pest-control-concentrate-for-yard-garden-32oz',
      '/products/outdoor-pest-control-concentrate-for-yard-garden-128oz'],
  ],
]);

const productRecoSliderElement = $('#quiz-container .question-outer');
const prtInfo = {
  linkRedirectDelay:300,
  nextSlideDelay: 200,
  sliderSettings: {
    accessibility: false,
    fade: false,
    arrows: false,
    cssEase: 'cubic-bezier(.02, .01, .47, 1)',
    swipe: false,
    adaptiveHeight: false,
    infinite: false,
    speed: 300
  }
};

Object.size = function (obj) {
  let size = 0,
    key;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) size++;
  }
  return size;
};

function slick_goto(index) {
  const selectedElement = $('#quiz-container .question-block--answer.current_selection');
  const $answerCurrent = selectedElement.map(function () {
    return $(this).data('score');
  }).get();
  localStorage.setItem('answerCurrent', $answerCurrent);

  if (!selectedElement.hasClass('question-block--link')) {
    productRecoSliderElement.slick('slickGoTo', index);
  } else {
    setTimeout(() => array_compare($answerCurrent), prtInfo.linkRedirectDelay);
  }
}

function array_compare(arr1) {
  let count = scoreJson.length,
    base_compare = {};
  $.each(scoreJson, function (index, row) {
    let obj = {},
      match = [],
      tags = row.tags;
    $.grep(tags, function (el) {
      if ($.inArray(el, arr1) != -1) {
        match.push(el);
      }
    });
    obj[index] = match;
    if (tags.length == obj[Object.keys(obj)[0]].length && (obj[Object.keys(obj)[0]].length > Object.size(base_compare))) {
      base_compare = obj;
    }
    if (!--count) {
      const scoreRow = $.map(base_compare, function (val, key) {
        return key
      });
      const $answersCurrent = localStorage.getItem('answerCurrent');
      localStorage.setItem('showMessage', 'true');
      getLinkByData($answersCurrent, scoreJson[scoreRow].url);
    }
  });
}

function getLinkByData($answers, $default) {
  let BreakException = {};
  let count = 1;
  try {
    linksArr.forEach(function (value, key) {
      if (key === $answers) {
        window.location.href = 'https://www.wondercide.com' + value;
        throw BreakException;
      } else {
        if (count === linksArr.size - 1 && key !== $answers) {
          window.location.href = 'https://www.wondercide.com' + $default;
        }
      }
      count++;
    });
  } catch (e) {
    if (e !== BreakException) throw e;
  }
}

function digestQuestion(num,val) {
  window.dataLayer=window.dataLayer||[];window.dataLayer.push({'prtData':{num,val},'event':'prtProgress'});
}

function chooseLinkByData($val) {
  const $answersCurrent = localStorage.getItem('answerCurrent');
  yardsArr.forEach(function (value, key) {
    if (key === $answersCurrent) {
      localStorage.setItem('showMessage', 'true');
      if ($val <= 2000) {
        window.location.href = 'https://www.wondercide.com' + value['0'] + '?reco=quiz';
      } else if ($val <= 5000) {
        window.location.href = 'https://www.wondercide.com' + value['1'] + '?reco=quiz';
      } else {
        window.location.href = 'https://www.wondercide.com' + value['2'] + '?reco=quiz';
      }
    }
  });
}

$(document).ready(function () {
  localStorage.setItem('currentSlide','0');
  productRecoSliderElement.slick(prtInfo.sliderSettings);
});

productRecoSliderElement.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  if (nextSlide === 0) {
    $('#quiz-container .slick-back').css('display', 'none');
  } else {
    $('#quiz-container .slick-back').css('display', 'inline-block');
  }
  const barProgress = {0:10,1:35,2:55,3:70,4:80,5:95,6:90,7:80};
  $('#quiz-container #quiz-progress-bar').css('width', `${barProgress[nextSlide]}%`);
  localStorage.setItem('currentSlide', nextSlide);
});

$(document).on('click', '#quiz-container .slick-back', function (e) {
  e.preventDefault();
  $('#quiz-container .question-block--answer').removeClass('current_selection');
  window.dataLayer=window.dataLayer||[];
  const $currentSlide = localStorage.getItem('currentSlide');
  window.dataLayer.push({'prtData':{num:$currentSlide},'event':'prtReverse'});

  if ($currentSlide === '7') {
    productRecoSliderElement.slick('slickGoTo', 2);
    $('#quiz-container #locationField').css('display', 'none');
    $('#quiz-container').css('padding-bottom', '');
    setTimeout(() => $('#quiz-container .on-pet-q').css('opacity',''),prtInfo.nextSlideDelay);
  } else if ($currentSlide === '6') {
    productRecoSliderElement.slick('slickGoTo', 3);
    setTimeout(() => $('#quiz-container .on-dog-q').css('opacity',''),prtInfo.nextSlideDelay);
  } else {
    productRecoSliderElement.slick('slickPrev');
  }
});

productRecoSliderElement.on('click', '.question-block:not(#triple-block) .question-block--answer', function (e) {
  e.preventDefault();
  const $el = $(this),
    curr_index = $el.closest('.question-block').data('slick-index'),
    new_index = $el.hasClass('question-block--cat') ? 6 : parseInt(curr_index) + 1;
  $el.addClass('current_selection');

  if ($el.hasClass('question-block--cat')) {
    $('#quiz-container .on-dog-q').css('opacity', 0);
  }

  setTimeout(function () {
    slick_goto(new_index);
  }, prtInfo.nextSlideDelay);
});

productRecoSliderElement.on('click', '#triple-block .reco-next-btn', e => {
  const checkedBoxes = [];
  document.querySelectorAll('.issue-checkbox:checked').forEach(el => checkedBoxes.push(el.id));
  const issueBoxesContain = key => checkedBoxes[0] === key || checkedBoxes[1] === key;
  let answer,rest;

  if (checkedBoxes.length === 3) {
    answer = 'everywhere';
    /* TODO : ? change to 'Pet, Home, and Yard' ? */
  } else if (issueBoxesContain('issue-on-pet')) {
    if (checkedBoxes.length === 1) {
      answer = 'pet';
    } else if (issueBoxesContain('issue-in-home')) {
      answer = 'pet-and-home';
    } else if (issueBoxesContain('issue-in-yard')) {
      answer = 'pet-yard';
    }
  } else if (issueBoxesContain('issue-in-yard')) {
    answer = 'yard';
    if (issueBoxesContain('issue-in-home')) {
      rest = '-home';
    }
    $('#quiz-container .on-pet-q').css('opacity', 0);
  } else if (issueBoxesContain('issue-in-home')) {
    answer = 'home';
  }
  digestQuestion(2,rest ? answer+rest : answer);
  $(`#quiz-container #triple-block .question-block--answer.${answer}`).addClass('current_selection');

  setTimeout(function () {
    if (answer === 'yard') {
      $('#quiz-container #locationField').css('display', 'flex');
      $('#quiz-container').css('padding-bottom', '0');
      const locationFieldOffset = $("#quiz-container .question-outer .yard-sqf")[0].clientHeight - $("#quiz-container .question-outer")[0].clientHeight;
      $({x: 200}).animate({x: 0}, {
        duration: prtInfo.sliderSettings.speed,
        step: function (val) {
          $('#quiz-container #locationField').css("transform", `translate(${val}%, ${locationFieldOffset}px)`);
          $('#quiz-container .message').css("transform", `translate(${val}%, ${locationFieldOffset}px)`);
        }
      });
      slick_goto(8);
    } else {
      slick_goto(3);
    }
  }, prtInfo.nextSlideDelay);
});

$(document).on('click', '#quiz-container .slick-active', function () {
  const $prevSlide = $(this).attr('data-slick-index');
  localStorage.setItem('prevSlide', $prevSlide);
  const $currentSlide = localStorage.getItem('currentSlide');
});

$(document).on('click', '#quiz-container #go-to-url', function (e) {
  e.preventDefault();
  digestQuestion(7,'Size submit');
  const $val = $('#quiz-container #yard-large').val();
  chooseLinkByData($val);
});

let placeSearch;
let autocomplete;
const componentForm = {
  street_number: "short_name",
  route: "long_name",
  locality: "long_name",
  administrative_area_level_1: "short_name",
  country_name: "long_name",
  postal_code: "short_name",
};

function initAutocomplete() {
  /* Create the autocomplete object, restricting the search predictions to geographical location types. */
  autocomplete = new google.maps.places.Autocomplete(
    document.querySelector("#quiz-container #autocomplete"),
    {types: ["geocode"]}
  );
  /* Avoid paying for data that you don't need by restricting the set of place fields that are returned to just the address components. */
  autocomplete.setFields(["address_component"]);
  /* When the user selects an address from the drop-down, populate the address fields in the form. */
  autocomplete.addListener("place_changed", fillInAddress);
}

function fillInAddress() {
  /* Get the place details from the autocomplete object. */
  const place = autocomplete.getPlace();

  for (const component in componentForm) {
    document.querySelector(`#quiz-container #${component}`).value = "";
    document.querySelector(`#quiz-container #${component}`).disabled = false;
  }

  /* Get each component of the address from the place details, and then fill-in the corresponding field on the form. */
  for (const component of place.address_components) {
    const addressType = component.types[0] !== "country" ? component.types[0] : "country_name";
    const componentCheck = {
      street_number: "street number",
      route: "route",
      locality: "locality",
      administrative_area_level_1: "administrative area",
      country_name: "country",
      postal_code: "postal code",
    };

    if (componentForm[addressType]) {
      document.querySelector(`#quiz-container #${addressType}`).value = component[componentForm[addressType]];
    }
  }
}

function geolocate() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(position => {
      const geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      const circle = new google.maps.Circle({
        center: geolocation,
        radius: position.coords.accuracy,
      });
      autocomplete.setBounds(circle.getBounds());
    });
  }
}

$(document).on('click', '#quiz-container #send-to-api', function (e) {
  e.preventDefault();
  digestQuestion(7,'Address submit');
  const spinnerElement = $('#quiz-container .spinner-wrapp')
  spinnerElement.css('display', 'block');
  const $streetNumber = $('#quiz-container #street_number').val();
  const $route = $('#quiz-container #route').val();
  const $locality = $('#quiz-container #locality').val();
  const $administrativeArea = $('#quiz-container #administrative_area_level_1').val();
  const $postalCode = $('#quiz-container #postal_code').val();
  const $country = $('#quiz-container #country').val();
  if (!$streetNumber.trim() || !$route.trim() || !$locality.trim() || !$administrativeArea.trim() || !$postalCode.trim()) {
    spinnerElement.css('display', 'none');
    $('#quiz-container .message').css('display', 'block');
  } else {
    const settings = {
      "url": "https://api.bridgedataoutput.com/api/v2/pub/parcels?access_token=" +
        "66ef505068d7087cfcf8436b079cc165" +
        "&address.full.in=" + $streetNumber + ' ' + $route + ',' + $locality + ',' + $administrativeArea + ' ' + $postalCode,
      "method": "GET",
      "timeout": 0,
    };

    /* address capture */
    $.post("https://reactr.wondercide.com/address/receive", {
      address: $streetNumber + ' ' + $route,
      city: $locality,
      state: $administrativeArea,
      zip: $postalCode,
      version: 2
    });

    $.ajax(settings).done(function (response) {
      if (response.success == 1) {
        const $lotSize = response.bundle.length;
        if ($lotSize !== 0) {
          const dataApi = response.bundle['0'].lotSizeSquareFeet - 2000;
          chooseLinkByData(Math.round(dataApi));
        } else {
          spinnerElement.css('display', 'none');
          $('#quiz-container .message').css('display', 'block');
        }
      }
    })
  }
});

/* TODO : improve post-AB */
$(document).on('click', '#quiz-container .fleas', function (e) {
  digestQuestion(0,'Fleas/Ticks');
});
$(document).on('click', '#quiz-container .ants', function (e) {
  digestQuestion(0,'Ants/Roaches');
});
$(document).on('click', '#quiz-container .spiders', function (e) {
  digestQuestion(0,'Spiders');
});
$(document).on('click', '#quiz-container .other', function (e) {
  digestQuestion(0,'Other');
});
$(document).on('click', '#quiz-container .mosquito', function (e) {
  digestQuestion(0,'Mosquitoes');
});


$(document).on('click', '#quiz-container .active-2', function (e) {
  digestQuestion(1,'Active issue');
});
$(document).on('click', '#quiz-container .prevention-2', function (e) {
  digestQuestion(1,'Prevention/maintenance');
});


$(document).on('click', '#quiz-container .dog', function (e) {
  digestQuestion(3,'Dog');
});
$(document).on('click', '#quiz-container .cat', function (e) {
  digestQuestion(3,'Cat');
});
$(document).on('click', '#quiz-container .both', function (e) {
  digestQuestion(3,'Both');
});


$(document).on('click', '#quiz-container .1-dog', function (e) {
  digestQuestion(4,'One dog');
});
$(document).on('click', '#quiz-container .2-dog', function (e) {
  digestQuestion(4,'Two or more dogs');
});


$(document).on('click', '#quiz-container .dog-s', function (e) {
  digestQuestion(5,'Small dog');
});
$(document).on('click', '#quiz-container .dog-m', function (e) {
  digestQuestion(5,'Medium dog');
});
$(document).on('click', '#quiz-container .dog-l', function (e) {
  digestQuestion(5,'Large dog');
});


$(document).on('click', '#quiz-container .1-cat', function (e) {
  digestQuestion(6,'One cat');
});
$(document).on('click', '#quiz-container .2-cats', function (e) {
  digestQuestion(6,'Two or more cats');
});

const reslickProductRecoModal = nextSlide => {
  if (nextSlide > -1) {
    prtInfo.sliderSettings.initialSlide = nextSlide;
  }
  productRecoSliderElement.slick('unslick').slick(prtInfo.sliderSettings);
};

const openProductRecoModal = () => {
  $.magnificPopup.open({
    items: {
      src: '#product-reco-modal',
      type: 'inline'
    },
    mainClass: 'reco-modal-container',
    callbacks: {
      open: function() {
        reslickProductRecoModal();
        theme.DesktopNav.closeDesktopNav();
        theme.MobileNav.closeMobileNav();

        const timePromise = new Promise(resolve => setTimeout(resolve, 2500));
        const clickPromise = new Promise(resolve => productRecoSliderElement.on('click',resolve));
        Promise.race([timePromise,clickPromise]).then(() => {
          productRecoSliderElement.slick('slickGoTo',1,true);
          productRecoSliderElement.slick('slickGoTo',0,true);
        });
      },
      close: function () {
        window.dataLayer=window.dataLayer||[];window.dataLayer.push({'prtData':{num:localStorage.getItem('currentSlide')},'event':'prtEnd'});
        $('#quiz-container #locationField').css('display', 'none');
        $('#quiz-container').css('padding-bottom', '');
        productRecoSliderElement.slick('slickGoTo', 0);
        $('#quiz-container .question-block--answer').removeClass('current_selection');
        $('#quiz-container #triple-block .issue-checkbox').each((i, el) => {
          el.checked = false;
        });
        if (window.location.hash === '#product-quiz') window.location.hash = '';
      }
    }
  });
};

if (window.location.hash === '#product-quiz') {
  $(() => {
    setTimeout(openProductRecoModal,0);
  });
}

$(document).on('click', '.open-prt-link', function (e) {
  e.preventDefault();
  window.location.hash = '#product-quiz';
  openProductRecoModal();
});